import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../lib/supabase'
import TimeFavoritoSelector from '../components/TimeFavoritoSelector'

export default function Perfil() {
  const { usuario, carregarUsuario, user } = useAuth()
  const navigate = useNavigate()

  const [form, setForm] = useState({
    primeiro_nome: usuario?.primeiro_nome || '',
    ultimo_nome: usuario?.ultimo_nome || '',
    whatsapp: usuario?.whatsapp || '',
  })
  const [timeFavorito, setTimeFavorito] = useState(usuario?.time_favorito || null)
  const [salvandoTime, setSalvandoTime] = useState(false)
  const [senhaForm, setSenhaForm] = useState({ atual: '', nova: '', confirmar: '' })
  const [loading, setLoading] = useState(false)
  const [loadingSenha, setLoadingSenha] = useState(false)
  const [msg, setMsg] = useState(null)
  const [showAtual, setShowAtual] = useState(false)
  const [showNova, setShowNova] = useState(false)

  function showMsg(texto, tipo = 'ok') {
    setMsg({ texto, tipo })
    setTimeout(() => setMsg(null), 3500)
  }

  function validarWhatsApp(v) {
    const nums = v.replace(/\D/g, '')
    return nums.length >= 8 && nums.length <= 15
  }

  async function salvarDados() {
    if (!form.primeiro_nome.trim() || !form.ultimo_nome.trim()) {
      return showMsg('Nome e sobrenome são obrigatórios.', 'erro')
    }
    if (form.whatsapp && !validarWhatsApp(form.whatsapp)) {
      return showMsg('WhatsApp inválido. Brasil: DDD + número (ex: 11999998888). Internacional: com + e código do país (ex: +351987654321).', 'erro')
    }
    setLoading(true)
    const { error } = await supabase.from('usuarios').update({
      primeiro_nome: form.primeiro_nome.trim(),
      ultimo_nome: form.ultimo_nome.trim(),
      whatsapp: form.whatsapp.replace(/\D/g, '') || null,
    }).eq('id', usuario.id)
    setLoading(false)
    if (error) {
      showMsg('Erro ao salvar: ' + error.message, 'erro')
    } else {
      await carregarUsuario(user.id)
      showMsg('Dados atualizados com sucesso!')
    }
  }

  async function salvarSenha() {
    if (!senhaForm.nova || senhaForm.nova.length < 8) {
      return showMsg('A nova senha deve ter pelo menos 8 caracteres.', 'erro')
    }
    if (!/[A-Z]/.test(senhaForm.nova)) {
      return showMsg('A senha deve ter pelo menos uma letra maiúscula.', 'erro')
    }
    if (!/[0-9]/.test(senhaForm.nova)) {
      return showMsg('A senha deve ter pelo menos um número.', 'erro')
    }
    if (senhaForm.nova !== senhaForm.confirmar) {
      return showMsg('As senhas não coincidem.', 'erro')
    }
    setLoadingSenha(true)
    const { error } = await supabase.auth.updateUser({ password: senhaForm.nova })
    setLoadingSenha(false)
    if (error) {
      showMsg('Erro: ' + error.message, 'erro')
    } else {
      setSenhaForm({ atual: '', nova: '', confirmar: '' })
      showMsg('Senha alterada com sucesso!')
    }
  }

  function forcaSenha(s) {
    if (!s) return null
    let pts = 0
    if (s.length >= 8) pts++
    if (/[A-Z]/.test(s)) pts++
    if (/[0-9]/.test(s)) pts++
    if (/[^A-Za-z0-9]/.test(s)) pts++
    if (pts <= 1) return { label: 'Fraca', cor: '#E24B4A', largura: '30%' }
    if (pts === 2) return { label: 'Média', cor: '#F5A623', largura: '60%' }
    return { label: 'Forte', cor: '#3B6D11', largura: '100%' }
  }

  const forca = forcaSenha(senhaForm.nova)

  return (
    <div style={s.wrap}>
      <div style={s.titulo}>Meu perfil</div>

      {msg && (
        <div style={msg.tipo === 'ok' ? s.msgOk : s.msgErro}>
          {msg.texto}
        </div>
      )}

      {/* Dados pessoais */}
      <div style={s.card}>
        <div style={s.cardTitle}>👤 Dados pessoais</div>

        <div style={s.row}>
          <div style={s.field}>
            <label style={s.label}>Nome</label>
            <input
              style={s.input}
              value={form.primeiro_nome}
              onChange={e => setForm({ ...form, primeiro_nome: e.target.value })}
              placeholder="Seu nome"
              maxLength={50}
            />
          </div>
          <div style={s.field}>
            <label style={s.label}>Sobrenome</label>
            <input
              style={s.input}
              value={form.ultimo_nome}
              onChange={e => setForm({ ...form, ultimo_nome: e.target.value })}
              placeholder="Seu sobrenome"
              maxLength={50}
            />
          </div>
        </div>

        <div style={s.field}>
          <label style={s.label}>WhatsApp</label>
          <div style={s.inputWrap}>
            <span style={s.inputPrefix}>📱</span>
            <input
              style={{ ...s.input, paddingLeft: 28 }}
              value={form.whatsapp}
              onChange={e => setForm({ ...form, whatsapp: e.target.value })}
              placeholder="Ex: 11999998888 ou +351987654321"
              maxLength={16}
              type="tel"
            />
          </div>
          <div style={s.hint}>Brasil: DDD + número (ex: 11999998888). Internacional: com + e código do país (ex: +351987654321).</div>
        </div>

        <div style={s.emailRow}>
          <span style={s.label}>E-mail</span>
          <span style={s.emailVal}>{user?.email}</span>
          <span style={s.emailNote}>não editável</span>
        </div>

        <button style={s.btn} onClick={salvarDados} disabled={loading}>
          {loading ? 'Salvando...' : 'Salvar dados'}
        </button>
      </div>

      {/* Time favorito */}
      <div style={s.card}>
        <div style={s.cardTitle}>🏈 Time favorito</div>
        <TimeFavoritoSelector valor={timeFavorito} onChange={setTimeFavorito} />
        <button
          style={{ ...s.btn, marginTop: 14 }}
          disabled={salvandoTime}
          onClick={async () => {
            setSalvandoTime(true)
            const { error } = await supabase.from('usuarios')
              .update({ time_favorito: timeFavorito })
              .eq('id', usuario.id)
            setSalvandoTime(false)
            if (error) showMsg('Erro ao salvar time.', 'erro')
            else { await carregarUsuario(user.id); showMsg('Time favorito salvo!') }
          }}
        >
          {salvandoTime ? 'Salvando...' : 'Salvar time favorito'}
        </button>
      </div>

      {/* Alterar senha */}
      <div style={s.card}>
        <div style={s.cardTitle}>🔒 Alterar senha</div>

        <div style={s.field}>
          <label style={s.label}>Nova senha</label>
          <div style={s.inputWrap}>
            <input
              style={s.input}
              type={showNova ? 'text' : 'password'}
              value={senhaForm.nova}
              onChange={e => setSenhaForm({ ...senhaForm, nova: e.target.value })}
              placeholder="Mínimo 8 caracteres"
            />
            <button style={s.eyeBtn} onClick={() => setShowNova(v => !v)} type="button">
              {showNova ? '🙈' : '👁'}
            </button>
          </div>
          {forca && (
            <div style={{ marginTop: 5 }}>
              <div style={{ ...s.forcaBar, width: forca.largura, background: forca.cor }} />
              <div style={{ fontSize: 10, color: forca.cor, marginTop: 2 }}>Senha {forca.label}</div>
            </div>
          )}
          <div style={s.hint}>Mínimo 8 caracteres, 1 maiúscula e 1 número.</div>
        </div>

        <div style={s.field}>
          <label style={s.label}>Confirmar nova senha</label>
          <div style={s.inputWrap}>
            <input
              style={{
                ...s.input,
                borderColor: senhaForm.confirmar && senhaForm.nova !== senhaForm.confirmar ? '#E24B4A' : undefined
              }}
              type={showAtual ? 'text' : 'password'}
              value={senhaForm.confirmar}
              onChange={e => setSenhaForm({ ...senhaForm, confirmar: e.target.value })}
              placeholder="Repita a nova senha"
            />
            <button style={s.eyeBtn} onClick={() => setShowAtual(v => !v)} type="button">
              {showAtual ? '🙈' : '👁'}
            </button>
          </div>
          {senhaForm.confirmar && senhaForm.nova !== senhaForm.confirmar && (
            <div style={{ fontSize: 11, color: '#E24B4A', marginTop: 3 }}>As senhas não coincidem</div>
          )}
        </div>

        <button style={s.btn} onClick={salvarSenha} disabled={loadingSenha}>
          {loadingSenha ? 'Alterando...' : 'Alterar senha'}
        </button>
      </div>

      {/* Participar de outra liga */}
      <div style={s.card}>
        <div style={s.cardTitle}>🏆 Participar de outra liga</div>
        <p style={{ fontSize: 13, color: '#555', margin: '0 0 12px' }}>
          Quer entrar em uma nova liga? Veja as ligas disponíveis e solicite sua inscrição.
        </p>
        <button style={{ ...s.btn, background: '#D85A30' }} onClick={() => navigate('/ligas')}>
          Ver ligas disponíveis →
        </button>
      </div>
    </div>
  )
}

const s = {
  wrap: { maxWidth: 480, margin: '0 auto' },
  titulo: { fontSize: 18, fontWeight: 600, color: '#0A2342', marginBottom: '1rem' },
  card: { background: 'white', border: '0.5px solid #eee', borderRadius: 10, padding: '16px', marginBottom: '1rem' },
  cardTitle: { fontSize: 13, fontWeight: 600, color: '#0A2342', marginBottom: 14 },
  row: { display: 'flex', gap: 10, marginBottom: 12 },
  field: { flex: 1, marginBottom: 12 },
  label: { display: 'block', fontSize: 12, color: '#555', marginBottom: 4, fontWeight: 500 },
  input: { width: '100%', padding: '9px 10px', border: '0.5px solid #ddd', borderRadius: 7, fontSize: 13, boxSizing: 'border-box', outline: 'none' },
  inputWrap: { position: 'relative', display: 'flex', alignItems: 'center' },
  inputPrefix: { position: 'absolute', left: 8, fontSize: 13, pointerEvents: 'none' },
  eyeBtn: { position: 'absolute', right: 8, background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, padding: 0 },
  hint: { fontSize: 10, color: '#aaa', marginTop: 3 },
  emailRow: { display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0', marginBottom: 12, borderTop: '0.5px solid #f5f5f5', borderBottom: '0.5px solid #f5f5f5' },
  emailVal: { fontSize: 13, color: '#333', flex: 1 },
  emailNote: { fontSize: 10, color: '#bbb' },
  btn: { width: '100%', padding: '10px', background: '#0A2342', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500 },
  msgOk: { background: '#EAF3DE', border: '0.5px solid #3B6D11', borderRadius: 8, padding: '10px 12px', marginBottom: '1rem', fontSize: 13, color: '#3B6D11' },
  msgErro: { background: '#FCEBEB', border: '0.5px solid #A32D2D', borderRadius: 8, padding: '10px 12px', marginBottom: '1rem', fontSize: 13, color: '#A32D2D' },
  forcaBar: { height: 3, borderRadius: 99, transition: 'width .3s, background .3s' },
}
